import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';
import { InvoiceType } from '../enums';
import { SelectItem } from '@web/shared/ui';

@Injectable({
  providedIn: 'root',
})
export class InvoiceTypeProviderService {
  private readonly entries = new Map<InvoiceType, string>([
    [InvoiceType.Temporary, 'Proforma'],
    [InvoiceType.Purchase, 'Faktura zakupowa'],
    [InvoiceType.Correction, 'Faktura korygująca'],
  ]);

  public labelFor(status: InvoiceType): Observable<string> {
    const result = this.entries.get(status);

    if (isNil(result)) {
      throw new EntryNotFoundException(
        `The entry for "${status}" is not found.`,
      );
    }

    return of(result);
  }

  public selectItems(): Observable<SelectItem<InvoiceType>[]> {
    return of(
      Array.from(this.entries.entries()).map(
        ([type, label]) => new SelectItem<InvoiceType>(label, type),
      ),
    );
  }
}
